<template>
  <div>
    <el-dialog
      lock-scroll
      :modal-append-to-body="false"
      :append-to-body="true"
      :title="$lang('批量导入')"
      :close-on-click-modal="false"
      :visible="visible"
      @close="close"
      width="600px">
      <div class="overflow">
        <div class="upload-item">
          <div class="upload">
            <!--:data="{type:2}"-->
            <el-upload
              ref="upload"
              :action="uploadData"
              :headers="header"
              :multiple="false"
              list-type="text"
              :limit="1"
              accept=".xls,.xlsx"
              :show-file-list="false"
              :on-change="handleChange"
              :on-success="onSuccess"
              :on-error="onError"
              :auto-upload="false"
              :on-exceed="onExceed">
              <template slot="default">
                <div class="upload-area">
                  <svg class="icon" aria-hidden="true" v-if="!isActive">
                    <use xlink:href="#iconwendang-moren"></use>
                  </svg>
                  <svg class="icon" aria-hidden="true" v-else>
                    <use xlink:href="#iconwendang-jihuo"></use>
                  </svg>
                  <p class="name">{{ text || $lang('点击此处选择Excel文档') }}</p>
                </div>
              </template>
            </el-upload>
          </div>
          <div class="button">
            <el-button type="info select" @click="clearFile" v-if="isActive">{{ $lang('重新选择') }}</el-button>
            <el-button type="primary" @click="upload" :loading="upLoading" v-if="text && noError">{{ $lang('立即上传') }}</el-button>
          </div>
        </div>
      </div>
      <div class="tips">
        <p>{{ $lang('1、请按照模板内容字段内容顺序正确填写，并按照指定模板内容导入；') }}</p>
        <p>{{ $lang('2、单次最多导入200条数据；') }}</p>
        <p>{{ $lang('3、请注意：已取消或已揽收订单不可修改件数；订单号与运单号不得同时为空；') }}</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BatchUpload',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      uploadData: process.env.VUE_APP_API_URL + '/vip/excel/upload/package/number/template',
      upLoading: false,
      isActive: false,
      text: '',
      noError: true,
      resultText: '' // 上传成功提示语
    }
  },
  computed: {
    ...mapGetters({
      user: 'user',
      lang: 'lang'
    }),
    // 用户信息
    userInfo() {
      return this.$store.state.base.user || {}
    },
    header() {
      return {
        'authToken': this.userInfo.token,
        'language': localStorage.getItem('lang') || this.lang
      }
    },
  },
  created() {

  },
  methods: {
    handleChange(file) {
      //  排除上传成功和失败，只有刚读取的文件才执行上传
      if (!file || file.status !== 'ready') {
        return
      }
      this.text = file.name
      this.isActive = true
    },
    onSuccess(res) {
      const { code, data, msg } = res
      if (code === 1) {
        if (data.success.length === 0) {
          this.$message.error(this.$lang('导入失败'))
        } else {
          this.$message.success(this.$lang('导入成功'))
        }
        // const text = [...this.$lang('%条修改成功，请打印最新的面单。%条修改失败，请检查订单状态是否为未揽收。')]
        // const index1 = text.findIndex(item => item === '%')
        // text[index1] = data.success.length
        // const index2 = text.findIndex(item => item === '%')
        // text[index2] = data.fail.length
        // this.$message.info(text.join(''))
        console.log(data)
        this.clearFile()
      } else {
        this.$message.error(this.$lang(msg))
        this.noError = false
      }
      this.upLoading = false
    },
    clearFile() {
      this.$nextTick(() => {
        this.$refs['upload'].clearFiles()
      })
      this.text = ''
      this.isActive = false
      this.noError = true
    },
    onError() {
      this.upLoading = false
    },
    upload() {
      this.upLoading = true
      this.$refs['upload'].submit()
    },
    onExceed() {
      this.$message.error(this.$lang('模板已存在,请重新选择'))
    },
    /**
     * 关闭弹窗
     */
    close() {
      this.$emit('update:visible', false)
      this.clearFile()
    },
    re(str, num1, num2) {

    },
  },
}
</script>

<style scoped lang="scss" scoped>
.overflow {
  text-align: center;
  border-bottom: 1px dashed rgba(238, 238, 238, 1);
  display: flex;
  justify-content: space-around;
}

.overflow p {
  font-size: 12px;
  color: #999;
}

.upload-area {
  margin-top: 45px;

  .file {
    font-size: 72px;
    background-image: linear-gradient(to bottom, #e0bd7b, #cfa561);
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .name {
    font-size: 14px;
  }

  .icon {
    font-size: 48px;
  }
}

.upload {
  display: inline-block;
  text-align: center;
  width: 180px;
  height: 170px;
  background: #f7f7f9;
  border-radius: 4px;
  border: 1px solid transparent;
  margin-top: 25px;
}

.tips {
  margin-top: 16px;
  font-size: 12px;
  color: #999;
}

.button {
  height: 60px;
  box-sizing: border-box;
  padding: 10px 15px;
}

button.select.is-disabled {
  color: #999;
  border-color: #ebeef5;
  background-color: #ebeef5;
}
</style>
